<template>
  <!-- 密码模态框 -->
  <el-dialog
    width="560px"
    :visible.sync="centerDialogVisible"
    class="changPw"
    :before-close="Passwordcolse"
  >
    <template slot="title">
      <i class="el-icon-warning"></i>
      <span style="font-size: 20px;padding: 0 10px;">关联总公司</span>
    </template>
    <el-form
      label-position="top"
      label-width="80px"
      :model="userInfopassword"
      status-icon
      :rules="passwordRules"
      ref="userInfopassword"
    >
      <span class="tips">检测到该账户未与总公司关联，请在下方进行关联后使用其他功能</span>
      <el-form-item prop label="该账号是否为总公司：" class="sex">
        <div class="singleSel">
          <el-radio v-model="YESorNO" @change="Rchange(false)" label="1">是</el-radio>
          <el-radio v-model="YESorNO" @change="Rchange(true)" label="2">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item prop="orgCode" v-if="showInput" label="输入或选择总公司统一社会信用代码">
        <el-input
          v-model="userInfopassword.orgCode"
          placeholder="请输入总公司统一社会信用代码"
          @click.native="showProperty()"
          size="mini"
        ></el-input>
        <property-comp v-if="this.$store.state.propertyComp" @getPropertyVal="getPropertyVal"></property-comp>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <ps-save type="primary" @click="submit('userInfopassword')">确 定</ps-save>
    </span>
  </el-dialog>
</template>

<script>
import { validatePassword } from '@/utils/validate';
import { AuthenticationControllerSvr } from '@/service/AuthenticationControllerSvr.js';
import { mapState } from 'vuex';
import { encrypt } from '@/utils/encryption.js';
import propertyComp from '@/components/common/propertyComp';
import { HomeControllerSvr } from '@/service/HomeControllerSvr';

export default {
  components: { propertyComp },
  computed: {
    ...mapState(['token']),
    ...mapState(['userInfo'])
  },
  props: { centerDialogVisible: Boolean },
  data() {
    return {
      YESorNO: '',
      showInput: '',
      userInfopassword: {
        orgCode: ''
      },
      DialogVisible: false,
      //密码确认验证
      passwordRules: {
        orgCode: [{ required: true, message: '不可为空', trigger: 'change' }]
      }
    };
  },
  created() {
    this.homeControllerSvr = new HomeControllerSvr();
    this.AuthenticationControllerSvr = new AuthenticationControllerSvr();
  },
  mounted() {},
  methods: {
    getPropertyVal(val) {
      this.userInfopassword.orgCode = val.OrgCode;
      // this.userInfopassword.orgCode = val.OrgName;
    },
    showProperty() {
      this.$store.state.propertyComp = true;
    },
    Rchange(value) {
      this.showInput = value;
    },
    //提交修改
    submit(formName) {
      if (this.YESorNO === '1') {
        this.homeControllerSvr
          .setHeadOffice(this.token, this.userInfo.UserParam.OrgCode)
          .then(res => {
            if (res === 'SUCCESS') {
              this.centerDialogVisible = false;
              this.$message({ message: '关联成功', type: 'success' });
            }
          })
          .catch(err => {});
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.homeControllerSvr
              .setHeadOffice(this.token, this.userInfopassword.orgCode)
              .then(res => {
                if (res === 'SUCCESS') {
                  this.centerDialogVisible = false;
                  this.$message({ message: '关联成功', type: 'success' });
                }
              })
              .catch(err => {});
          } else {
            return false;
          }
        });
      }
    },
    Passwordcolse() {
      this.$emit('close');
      this.resetForm('userInfopassword');
    },
    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
.changPw {
  .el-dialog__header {
    border-bottom: solid 1px #a5a5a5;
  }
  .el-dialog__body {
    padding: 10px 30px 0 20px;
    .tips {
      font-size: 16px;
      color: #ff6f6f;
      margin: 10px 0;
      display: block;
    }
    .el-form-item {
      margin-bottom: 30px;
      .el-form-item__label {
        line-height: 20px;
      }
    }
  }
  .el-dialog__footer {
    padding: 0 20px 20px;
  }
}
</style>